import {Component} from '@angular/core';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-accom-nb-and-sort-ph',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './accom-nb-and-sort-ph.component.html',
  styleUrl: './accom-nb-and-sort-ph.component.scss'
})
export class AccomNbAndSortPhComponent {

}
